import React, {MouseEventHandler, PropsWithChildren, ReactNode} from 'react';

interface Props {
  text?: ReactNode;
  margin?: boolean;
  padding?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  cy?: string;
}

const Button: React.FC<PropsWithChildren<Props>> = ({
  text,
  margin = true,
  padding = true,
  onClick,
  disabled,
  cy,
  children
}) => (
  <React.Fragment>
    <button
      type="submit"
      onClick={onClick}
      disabled={disabled ?? false}
      data-cy={cy}
    >
      {text ? text : children }
    </button>
    {/* language=CSS */}
    <style jsx>{`
      button {
        padding: ${padding ? '1rem 1rem' : '0.25rem 1rem'};
        margin: ${margin ? '1rem 0 0 0' : '0'};
        color: #fff;
        background: #707070;
        box-shadow: none;
        border: none;
        text-decoration: none;
        user-select: none;
        font-size: 14px;
        font-family: 'Volvo Novum', sans-serif;
        width: auto;
        cursor: pointer;
        transition: background 200ms ease-in-out;
      }

      button:hover {
        background: #7d7d7d;
      }

      button:disabled {
        background: #9f9f9f;
        cursor: not-allowed;
      }
    `}</style>
  </React.Fragment>
);

export default Button;
